import cookies from "js-cookie";
import ROUTES from "constants/routes";
import dayjs from "dayjs";

interface ICookie {
  name: string;
  value: string;
  options?: object;
}

const setCookie = (cookie: ICookie) => {
  cookies.set(cookie.name, cookie.value, {
    expires: dayjs().add(30, "d").toDate(),
    ...cookie.options,
  });
};

export const setAuthCookies = (_cookies: ICookie | ICookie[] = []) => {
  if (Array.isArray(_cookies)) {
    _cookies.forEach((cookie) => setCookie(cookie));
  } else setCookie(_cookies);
};

export const removeAllCookies = () => {
  const allCookies = cookies.get();

  Object.keys(allCookies).forEach((name) => {
    cookies.remove(name);

    cookies.remove(name, {
      domain: window.location.hostname,
      path: "/",
    });
  });
};

export const authRedirect = ({
  accessToken,
  refreshToken,
  redirectUrl,
}: {
  accessToken?: string;
  refreshToken?: string;
  redirectUrl: string;
}) => {
  if (accessToken && refreshToken) {
    setAuthCookies([
      { name: "accessToken", value: accessToken },
      { name: "refreshToken", value: refreshToken },
    ]);
  }
  document.location.href = redirectUrl || `${window.location.origin}/${ROUTES.COMPETENCE_MAPS}`;
};
